import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setSearchTxt } from '../../redux/actions/FilterAction';

const Search = ({}) => {
  const { searchTxt } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  return (
    <div style={styles.inputContainer}>
      {/* <SearchIcon /> */}

      <input
        style={styles.input}
        placeholder="search"
        type="text"
        name="searchTxt"
        value={searchTxt}
        onChange={(e) => dispatch(setSearchTxt(e.target.value))}
      />
    </div>
  );
};

const styles = {
  inputContainer: {
    border: '1px solid',
  },
  input: {
    width: '100%',
    border: '1px solid',
  },
};
export default Search;
